class CartRemoveButton extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', (event) => {
			event.preventDefault();
			this.closest('cart-items').updateQuantity(this.dataset.index, 0);
		});
	}
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
	constructor() {
		super();

		this.lineItemStatusElement = document.getElementById(
			'shopping-cart-line-item-status'
		);
		this.cartErrors = document.getElementById('cart-errors');

		this.currentItemCount = Array.from(
			this.querySelectorAll('[name="updates[]"]')
		).reduce(
			(total, quantityInput) => total + parseInt(quantityInput.value),
			0
		);

		this.debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, 300);

		this.addEventListener('change', this.debouncedOnChange.bind(this));

		setTimeout(() => {
			this.handleGwp();
		}, 1000);
	}

	onChange(event) {
		if (event.target === null) return;
		this.updateQuantity(
			event.target.dataset.index,
			event.target.value,
			document.activeElement.getAttribute('name')
		);
	}

	getSectionsToRender() {
		let sections = [
			{
				id: 'mini-cart',
				section: document.getElementById('mini-cart')?.id,
				selector: '.shopify-section',
			},
			{
				id: 'main-cart-items',
				section: document.getElementById('main-cart-items')?.dataset.id,
				selector: '.js-contents',
			},
			{
				id: 'cart-icon-bubble',
				section: 'cart-icon-bubble',
				selector: '.shopify-section',
			},
			{
				id: 'mobile-cart-icon-bubble',
				section: 'mobile-cart-icon-bubble',
				selector: '.shopify-section',
			},
			{
				id: 'cart-live-region-text',
				section: 'cart-live-region-text',
				selector: '.shopify-section',
			},
			{
				id: 'main-cart-footer',
				section: document.getElementById('main-cart-footer')?.dataset.id,
				selector: '.js-contents',
			},
		];
		if (document.querySelector('#main-cart-footer .free-shipping')) {
			sections.push({
				id: 'main-cart-footer',
				section: document.getElementById('main-cart-footer')?.dataset.id,
				selector: '.free-shipping',
			});
		}
		return sections;
	}

	updateQuantity(line, quantity, name, renderingGWP = false) {
		console.log(line);
		this.enableLoading(line);
		const sections = this.getSectionsToRender().map(
			(section) => section.section
		);
		let body;
		if (renderingGWP) {
			body = JSON.stringify({
				id: `${renderingGWP}`,
				quantity,
				sections: sections,
				sections_url: window.location.pathname,
			});
		} else {
			body = JSON.stringify({
				line,
				quantity,
				sections: sections,
				sections_url: window.location.pathname,
			});
		}

		fetch(`${window.routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);
				this.classList.toggle('is-empty', parsedState.item_count === 0);
				const cartFooter = document.getElementById('main-cart-footer');

				if (cartFooter)
					cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

				this.getSectionsToRender().forEach((section) => {
					const element = document.getElementById(section.id);
					if (element) {
						const elementToReplace =
							element.querySelector(section.selector) || element;

						if (elementToReplace && parsedState.sections[section.section]) {
							elementToReplace.innerHTML = this.getSectionInnerHTML(
								parsedState.sections[section.section],
								section.selector
							);
						}
					}
				});
				if (renderingGWP) {
					this.updateLiveRegions(line, parsedState.item_count);
					const lineItem = document.getElementById(`CartItem-${line}`);
					if (lineItem && name)
						lineItem.querySelector(`[name="${name}"]`).focus();
				}
				this.disableLoading();

				document.dispatchEvent(
					new CustomEvent('cart:updated', {
						detail: {
							cart: state,
						},
					})
				);

				if (
					document.body.classList.contains('template-cart') &&
					!renderingGWP
				) {
					this.handleGwp(parsedState);
				}
			})
			.catch(() => {
				this.querySelectorAll('.loading-overlay').forEach((overlay) =>
					overlay.classList.add('hidden')
				);
				this.disableLoading();
				if (this.cartErrors) {
					this.cartErrors.textContent = window.cartStrings.error;
				}
			});
	}

	handleGwp() {
		let cart;

		const cartObjPromise = new Promise((resolve, reject) => {
			fetch(`${window.routes.cart_url}.js`, {
				method: 'GET',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
			})
				.then((response) => response.json())
				.then((response) => {
					cart = response;
					resolve();
				})
				.catch(function (error) {
					reject();
					return;
				});
		});

		cartObjPromise
			.then(() => {
				// Handle wrong gwp in cart: wrong gwp or wrong threshold
				const wrongGwpCartItemIndex =
					cart.items.findIndex((cart_item) => {
						if (
							cart_item.properties !== null &&
							Object.hasOwn(cart_item.properties, 'GwpValue')
						) {
							let isWrongGwp = true;
							if (
								cart_item.variant_id == GWP_PRODUCT_VARIANT_ID &&
								parseInt(cart_item.properties.GwpValue) == GWP_THRESHOLD
							) {
								isWrongGwp = false;
							}
							return isWrongGwp;
						} else {
							return false;
						}
					}) + 1;

				if (wrongGwpCartItemIndex > 0) {
					this.enableLoading(wrongGwpCartItemIndex);
					const sections = this.getSectionsToRender().map(
						(section) => section.section
					);

					const body = JSON.stringify({
						line: wrongGwpCartItemIndex,
						quantity: 0,
						sections: sections,
						sections_url: window.location.pathname,
					});

					fetch(`${window.routes.cart_change_url}`, {
						...fetchConfig(),
						...{ body },
					})
						.then((response) => {
							return response.text();
						})
						.then(async (state) => {
							const parsedState = JSON.parse(state);
							this.classList.toggle('is-empty', parsedState.item_count === 0);
							const cartFooter = document.getElementById('main-cart-footer');

							if (cartFooter)
								cartFooter.classList.toggle(
									'is-empty',
									parsedState.item_count === 0
								);

							this.getSectionsToRender().forEach((section) => {
								const element = document.getElementById(section.id);
								if (element) {
									const elementToReplace =
										element.querySelector(section.selector) || element;

									if (
										elementToReplace &&
										parsedState.sections[section.section]
									) {
										elementToReplace.innerHTML = this.getSectionInnerHTML(
											parsedState.sections[section.section],
											section.selector
										);
									}
								}
							});

							this.updateLiveRegions(line, parsedState.item_count);

							this.disableLoading();
							this.updateGwpProductInCart(parsedState);
						})
						.catch(() => {
							this.querySelectorAll('.loading-overlay').forEach((overlay) =>
								overlay.classList.add('hidden')
							);
							this.disableLoading();
							if (this.cartErrors) {
								this.cartErrors.textContent = window.cartStrings.error;
							}
						});
				} else {
					this.updateGwpProductInCart(cart);
				}
			})
			.catch((err) => {
				console.error('Problem with handle GWP in cart');
				return;
			});
	}

	updateGwpProductInCart(cart) {
		if (!(GWP_PRODUCT_VARIANT_ID && GWP_THRESHOLD)) {
			return;
		}
		// Check if GWP is already added && the quantity is 1
		const findGwpItemIndex =
			cart.items.findIndex(
				(item) =>
					item.variant_id == GWP_PRODUCT_VARIANT_ID &&
					parseInt(item.properties.GwpValue) == GWP_THRESHOLD
			) + 1;

		const findGwpItem = cart.items.find(
			(item) =>
				item.variant_id == GWP_PRODUCT_VARIANT_ID &&
				parseInt(item.properties.GwpValue) == GWP_THRESHOLD
		);

		console.log(findGwpItem);

		// Compare the threshold with cart price
		if (findGwpItemIndex == 0 && cart.total_price >= GWP_THRESHOLD) {
			// add GWP_PRODUCT

			fetch(`${window.routes.cart_add_url}.js`, {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: JSON.stringify({
					id: GWP_PRODUCT_VARIANT_ID,
					quantity: 1,
					properties: {
						GwpValue: GWP_THRESHOLD,
					},
					sections: this.getSectionsToRender().map(
						(section) => section.section
					),
					sections_url: window.location.pathname,
				}),
			})
				.then((response) => response.json())
				.then((data) => {
					this.getSectionsToRender().forEach((section) => {
						const element = document.getElementById(section.id);
						if (element) {
							const elementToReplace =
								element.querySelector(section.selector) || element;

							if (elementToReplace && data.sections[section.section]) {
								elementToReplace.innerHTML = this.getSectionInnerHTML(
									data.sections[section.section],
									section.selector
								);
							}
						}
					});
				})
				.catch((error) => console.error('Request failed', error));
		} else if (findGwpItemIndex > 0 && cart.total_price < GWP_THRESHOLD) {
			// remove GWP_PRODUCT
			this.updateQuantity(findGwpItemIndex, 0, false, findGwpItem.variant_id);
		} else if (findGwpItem && findGwpItem.quantity > 1) {
			// Make sure gwp quantity is 1 (because constructor function init multiple times/ beyours bug)
			this.updateQuantity(findGwpItemIndex, 1, false, findGwpItem.variant_id);
		}
	}

	updateLiveRegions(line, itemCount) {
		if (this.currentItemCount === itemCount) {
			const quantityError = document.getElementById(`Line-item-error-${line}`);
			if (quantityError) {
				quantityError.querySelector('.cart-item__error-text').innerHTML =
					window.cartStrings.quantityError.replace(
						'[quantity]',
						document.getElementById(`Quantity-${line}`).value
					);
			}
		}

		this.currentItemCount = itemCount;

		if (this.lineItemStatusElement)
			this.lineItemStatusElement.setAttribute('aria-hidden', true);

		const cartStatus = document.getElementById('cart-live-region-text');
		if (cartStatus) {
			cartStatus.setAttribute('aria-hidden', false);

			setTimeout(() => {
				cartStatus.setAttribute('aria-hidden', true);
			}, 1e3);
		}
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector)?.innerHTML;
	}

	enableLoading(line) {
		const cartItems = document.getElementById('main-cart-items');
		if (cartItems) cartItems.classList.add('cart__items--disabled');

		const loadingOverlay = this.querySelectorAll('.loading-overlay')[line - 1];
		if (loadingOverlay) loadingOverlay.classList.remove('hidden');

		document.activeElement.blur();
		if (this.lineItemStatusElement)
			this.lineItemStatusElement.setAttribute('aria-hidden', false);
	}

	disableLoading() {
		const cartItems = document.getElementById('main-cart-items');
		if (cartItems) cartItems.classList.remove('cart__items--disabled');
	}

	renderContents(parsedState) {
		this.getSectionsToRender().forEach((section) => {
			const element = document.getElementById(section.id);

			if (element) {
				element.innerHTML = this.getSectionInnerHTML(
					parsedState.sections[section.id],
					section.selector
				);
			}
		});
	}
}
customElements.define('cart-items', CartItems);

class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			'change',
			debounce((event) => {
				const body = JSON.stringify({ note: event.target.value });
				fetch(`${window.routes.cart_update_url}`, {
					...fetchConfig(),
					...{ body },
				});
			}, 300)
		);
	}
}
customElements.define('cart-note', CartNote);

class DiscountCode extends HTMLElement {
	constructor() {
		super();

		if (isStorageSupported('session')) {
			this.setupDiscount();

			this.addEventListener('change', (event) => {
				window.sessionStorage.setItem('discount', event.target.value);
			});
		}
	}

	setupDiscount() {
		const discount = window.sessionStorage.getItem('discount');
		if (discount !== null) {
			this.querySelector('input[name="discount"]').value = discount;
		}
	}
}

customElements.define('discount-code', DiscountCode);

class ShippingCalculator extends HTMLElement {
	constructor() {
		super();

		this.setupCountries();

		this.errors = this.querySelector('#ShippingCalculatorErrors');
		this.success = this.querySelector('#ShippingCalculatorSuccess');
		this.zip = this.querySelector('#ShippingCalculatorZip');
		this.country = this.querySelector('#ShippingCalculatorCountry');
		this.province = this.querySelector('#ShippingCalculatorProvince');
		this.button = this.querySelector('button');
		this.button.addEventListener('click', this.onSubmitHandler.bind(this));
	}

	setupCountries() {
		if (Shopify && Shopify.CountryProvinceSelector) {
			// eslint-disable-next-line no-new
			new Shopify.CountryProvinceSelector(
				'ShippingCalculatorCountry',
				'ShippingCalculatorProvince',
				{
					hideElement: 'ShippingCalculatorProvinceContainer',
				}
			);
		}
	}

	onSubmitHandler(event) {
		event.preventDefault();

		this.errors.classList.add('hidden');
		this.success.classList.add('hidden');
		this.zip.classList.remove('invalid');
		this.country.classList.remove('invalid');
		this.province.classList.remove('invalid');
		this.button.classList.add('loading');
		this.button.setAttribute('disabled', true);

		const body = JSON.stringify({
			shipping_address: {
				zip: this.zip.value,
				country: this.country.value,
				province: this.province.value,
			},
		});
		let sectionUrl = `${window.routes.cart_url}/shipping_rates.json`;

		// remove double `/` in case shop might have /en or language in URL
		sectionUrl = sectionUrl.replace('//', '/');

		fetch(sectionUrl, { ...fetchConfig('javascript'), body })
			.then((response) => response.json())
			.then((parsedState) => {
				if (parsedState.shipping_rates) {
					this.success.classList.remove('hidden');
					this.success.innerHTML = '';

					parsedState.shipping_rates.forEach((rate) => {
						const child = document.createElement('p');
						child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
						this.success.appendChild(child);
					});
				} else {
					let errors = [];
					Object.entries(parsedState).forEach(([attribute, messages]) => {
						errors.push(
							`${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${
								messages[0]
							}`
						);
					});

					this.errors.classList.remove('hidden');
					this.errors.querySelector('.errors').innerHTML = errors.join('; ');
				}
			})
			.catch((e) => {
				console.error(e);
			})
			.finally(() => {
				this.button.classList.remove('loading');
				this.button.removeAttribute('disabled');
			});
	}
}

customElements.define('shipping-calculator', ShippingCalculator);
